import { BannerType } from "../banner/Banner";
import { Experiment, LanderConfig } from "../types/LanderConfig";
import { getCampaignCohortID } from "../experimentation/helper";

export function getExperiment(landerConfigBody: any): Experiment {
  const { experiment } = landerConfigBody;

  if (!experiment) {
    return {};
  }

  // Limit experiment based on target Customer Ids
  if (
    experiment.data?.targetCustomerIds &&
    Array.isArray(experiment.data.targetCustomerIds) &&
    !experiment.data.targetCustomerIds.includes(landerConfigBody.customerId)
  ) {
    return {};
  }

  // Check for ineligible split
  if (experiment.cohort === "ineligible") {
    return {};
  }

  return {
    key: experiment.experiment,
    cohort: experiment.cohort,
    data: experiment.data,
    dbKey: experiment.dbKey,
  };
}

export const getTypeID = (type: string) => {
  if (type === BannerType.AUCTION) return "auctions";
  if (type === BannerType.DBS) return "broker";
  return "other";
};

export const getChannelID = (
  inTreatmentCohort: boolean,
  landerConfig: LanderConfig
) => {
  const { cohort } = landerConfig.experiment || {};
  return inTreatmentCohort
    ? landerConfig.adSense.channel + `+${cohort}`
    : landerConfig.adSense.channel + "+control";
};

export const getBannerCampaignID = (
  inTreatmentCohort: boolean,
  cohort: string,
  type: string
) => {
  const typeID = getTypeID(type);
  const cohortID = getCampaignCohortID(inTreatmentCohort, cohort);
  return `x_dom-${typeID}_parkedpages_x_x_invest_${cohortID}_001`;
};

export const getSpinsCampaignID = (
  inTreatmentCohort: boolean,
  cohort: string,
  type: string
) => {
  const typeID = getTypeID(type);
  const cohortID = getCampaignCohortID(inTreatmentCohort, cohort);
  return `x_dom-${typeID}_parkedpages_x_x_invest_spins_${cohortID}_001`;
};

// eslint-disable-next-line complexity
export const getExperimentBannerLink = (
  inTreatmentCohort: boolean,
  landerConfig: LanderConfig
) => {
  const bannerLink = landerConfig?.lander?.banner?.link;
  const type = landerConfig?.lander?.banner?.type ?? "";
  const url = new URL(bannerLink ?? "");
  const { utmCampaignAuction, utmCampaignDBS, utmCampaignOther } =
    landerConfig?.experiment?.data || {};

  // Allow experiment data to override the campaign ID
  let campaignID = "";
  if (type === BannerType.AUCTION && utmCampaignAuction) {
    campaignID = utmCampaignAuction;
  } else if (type === BannerType.DBS && utmCampaignDBS) {
    campaignID = utmCampaignDBS;
  } else if (utmCampaignOther) {
    campaignID = utmCampaignOther;
  } else {
    campaignID = getBannerCampaignID(
      inTreatmentCohort,
      landerConfig?.experiment?.cohort,
      type
    );
  }

  url.searchParams.set("utm_campaign", campaignID);
  return decodeURIComponent(url.href);
};
